<template>
  <v-form @submit.prevent="onSubmit">
    <say-form :doc="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import SayForm from "@/views/user/exercises/say/SayForm";

export default {
  name: "RowEdit",
  components: {
    SayForm,
  },
  props: {
    id: String,
    doc: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onSubmit() {
      this.$emit("editCommit", this.doc);
    },
  },
};
</script>
